import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "model-detail-page" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-12"
}
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "detail-title mb-2" }
const _hoisted_5 = { class: "detail-provider" }
const _hoisted_6 = { class: "stat-card" }
const _hoisted_7 = { class: "stat-card-value" }
const _hoisted_8 = { class: "stat-card" }
const _hoisted_9 = { class: "stat-card-value stat-card-text" }
const _hoisted_10 = { class: "stat-card-sub-score" }
const _hoisted_11 = { class: "stat-card" }
const _hoisted_12 = { class: "stat-card-value stat-card-text" }
const _hoisted_13 = { class: "stat-card-sub-score" }
const _hoisted_14 = { class: "d-md-none mb-8" }
const _hoisted_15 = { class: "section-card mb-8" }
const _hoisted_16 = { class: "steerability-score mb-3" }
const _hoisted_17 = { class: "steerability-value" }
const _hoisted_18 = { class: "section-text mb-2" }
const _hoisted_19 = { class: "section-card mb-8" }
const _hoisted_20 = { class: "sticky-sidebar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_ModelNotFound = _resolveComponent("ModelNotFound")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_NutritionLabel = _resolveComponent("NutritionLabel")!
  const _component_SteerabilityAxis = _resolveComponent("SteerabilityAxis")!
  const _component_PrincipleScoreBars = _resolveComponent("PrincipleScoreBars")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "#5539EC"
          })
        ]))
      : (!_ctx.model)
        ? (_openBlock(), _createBlock(_component_ModelNotFound, { key: 1 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_v_breadcrumbs, {
              items: _ctx.breadcrumbs,
              class: "px-0 mb-4"
            }, {
              divider: _withCtx(() => [
                _createVNode(_component_v_icon, { size: "14" }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-chevron-right", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["items"]),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "8"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.model.displayName), 1),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.model.provider), 1)
                    ]),
                    _createVNode(_component_v_row, { class: "mb-8" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "4"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "stat-card-label" }, "HumaneScore", -1)),
                              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.model.humaneScore.toFixed(2)), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "4"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "stat-card-label" }, "Strongest Principle", -1)),
                              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.strongestPrincipleName), 1),
                              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.strongestPrincipleScore), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "4"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "stat-card-label" }, "Weakest Principle", -1)),
                              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.weakestPrincipleName), 1),
                              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.weakestPrincipleScore), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_NutritionLabel, { model: _ctx.model }, null, 8, ["model"])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "section-title mb-4" }, "Humane Steerability", -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "steerability-label" }, "Humane Steerability Score:", -1)),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.model.steerability.toFixed(2)), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(["steerability-badge", _ctx.steerabilityClass])
                        }, _toDisplayString(_ctx.steerabilityLabel), 3)
                      ]),
                      _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.steerabilityDescription), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "section-text-subtle mb-4" }, " Humane steerability measures both how responsive a model is to humane guidance (positive steerability) and how resilient it is to adversarial prompting (humane resilience). ", -1)),
                      _createVNode(_component_SteerabilityAxis, {
                        baseline: _ctx.model.humaneScore,
                        "good-persona": _ctx.model.scores.good_persona.HumaneScore ?? 0,
                        "bad-persona": _ctx.model.scores.bad_persona.HumaneScore ?? 0
                      }, null, 8, ["baseline", "good-persona", "bad-persona"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "section-title mb-4" }, "Scores by Principle", -1)),
                      _createVNode(_component_PrincipleScoreBars, { model: _ctx.model }, null, 8, ["model"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "d-none d-md-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_NutritionLabel, { model: _ctx.model }, null, 8, ["model"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
  ]))
}